"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var ForecastSimulationUpdateResultDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationUpdateResultDTO, _DomainObject_1$Domai);

  /**
   * @param nodes
   * @param conflicts
   */
  function ForecastSimulationUpdateResultDTO(nodes, conflicts) {
    var _this;

    _classCallCheck(this, ForecastSimulationUpdateResultDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationUpdateResultDTO).call(this));
    _this.nodes = nodes;
    _this.conflicts = conflicts;
    return _this;
  }

  return ForecastSimulationUpdateResultDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationUpdateResultDTO = ForecastSimulationUpdateResultDTO;